import { call, put, take, takeEvery, takeLatest, select } from 'redux-saga/effects'
import {
    LEADERS_UPDATE, FETCH_LEADERS, FETCH_LEADERS_ERROR, getLeaderboard, FETCH_LEADERS_SUCCESS, FETCH_LEADERS_LOADING, FETCH_USER_NUMBER, FETCH_USER_NUM_SUCCESS
} from '../constants/action-types';
import firebase from 'firebase';
import Leader from '../schemas/leader';

function* leadersUpdate() {



}

function* fetchUserNumber() {



    try {

        const response = yield call((() => firebase.functions().httpsCallable('getUserNum')()))
        // TODO: This is weird, the eventId should just be passed in the event object, so we don't have to do this object assign thing.
        yield put({ type: FETCH_USER_NUM_SUCCESS, payload: response.data })

    }

    catch (e) {
        yield put({ type: FETCH_LEADERS_ERROR, e: e.message })

    }

}

function* fetchLeaders({ sort = { by: 'bounty_points' } }) {

    yield put({ type: FETCH_LEADERS_LOADING })
    try {

        const payload = yield call((() => firebase.functions().httpsCallable(getLeaderboard)(sort)))
        yield put({ type: FETCH_LEADERS_SUCCESS, payload: payload.data.map(p => new Leader(Object.assign({}, p.leaderData, p.userData))) })

    } catch (e) {
        yield put({ type: FETCH_LEADERS_ERROR, e: e.message })

    }


}

export default [
    takeLatest(LEADERS_UPDATE, leadersUpdate),
    takeLatest(FETCH_USER_NUMBER, fetchUserNumber),
    takeLatest(FETCH_LEADERS, fetchLeaders)
]


// WEBPACK FOOTER //
// ./src/sagas/leaders.js